(function(window, angular, undefined) {

  angular.module('mfTrainee.filters', [])

    .filter('mediaTimeFilter', function() {
      return function(num) {
        if (num === undefined || isNaN(num))
          num = 0;

        // format from decimal to time
        var time = "";
        var hours, min, sec;

        // handle hours digit. don't show it if 0.
        hours = Math.floor(num / 3600);
        if (hours > 0)
          time = "0" + hours + ":";

        // handle minutes digit
        min = Math.floor((num - hours * 3600) / 60);
        if (min < 10)
          time = time + "0";
        time = time + min + ":";

        // handle seconds digit
        sec = "" + Math.floor(num - hours * 3600 - min * 60);
        if (sec < 10)
          time = time + "0";
        time = time + sec;
        return time;
      }
    })

    .filter('getFileSize', function() {
      return function(sizeInBytes) {
        var KB = 1024;
        var MB = KB * KB;
        if (sizeInBytes > MB)
          return Math.round((sizeInBytes / MB) * 100) / 100 + ' MB';
        else
          return Math.round((sizeInBytes / KB) * 100) / 100 + ' KB';
      }
    })

    .filter('hasIntersection', function() {
      return function(item, array) {
        return array.indexOf(item) >= 0;
      };
    })

    .filter('truncate', function() {
      //    https://gist.github.com/2478654
      /**
       * Example - see the jsfiddle: http://jsfiddle.net/tUyyx/
       *
       * var myText = "This is an example.";
       *
       * {{myText|truncate}}
       * {{myText|truncate:5}}
       * {{myText|truncate:25:" ->"}}
       *
       * Output
       * "This is..."
       * "Th..."
       * "This is an e ->"
       *
       */
      return function(text, length, end) {
        if (isNaN(length))
          length = 10;

        if (end === undefined)
          end = "...";

        if (!text)
          return;

        if (text.length <= length || text.length - end.length <= length) {
          return text;
        }
        else {
          return String(text).substring(0, length - end.length) + end;
        }
      };
    });

})(window, window.angular);
